import { getUserMe } from "@/services/me";
import { toLogin } from "@/utils/redirects";
import { getAuthToken } from "@/utils/token";
import router from "@/router";
import store from "@/store";

function changePasswordRedirect(to: any, from: any, next: any) {
  if (from.name == null && to.fullPath.includes("/password/reset?")) {
    next({
      name: "changepassword",
      query: {
        token: window.location.href.split("token=")[1],
      },
    });
  }
}

function setHeaderTitle(to: any, from: any, next: any) {
  document.title = to.meta.title + " - Auth";
  next();
}

async function isAuthenticated(to: any, from: any, next: any) {
  const authToken = getAuthToken();
  if ((from.name != "login" || from.path != "/") && !authToken) {
    return toLogin(undefined);
  } else {
    if (to.meta.admin === true) await isAdmin(to, from, next);
    next();
  }
}

async function isAdmin(to: any, from: any, next: any) {
  let me = null;

  try {
    const meState = store.getters["meState/me"];

    if (!meState.id) {
      const resMe = await getUserMe();
      me = resMe?.data;
    } else {
      me = { ...meState };
    }

    const hasLogPermission = me.roles && me.roles.some((r: any) => r.name === 'auth_logs');

    if (me.is_admin) {
      next();
      return;
    }

    if (to.name === 'logs' && hasLogPermission) {
      next();
      return;
    }

    return router.push({ name: "my-apps" });

  } catch (error) {
    return router.push({ name: "my-apps" });
  }
}

export default async (to: any, from: any, next: any): Promise<void> => {
  if (to.meta.authentication === true) await isAuthenticated(to, from, next);

  changePasswordRedirect(to, from, next);
  setHeaderTitle(to, from, next);
};
